type CampaignNavigationSequence = {
    createdAt?: string;
    requireManualApproval?: boolean | null;
};

export async function getPostLaunchCampaignRoute(campaignId: number) {
    try {
        const sequences = await $fetch<CampaignNavigationSequence[]>('/api/sequences', { query: { icpId: campaignId } });
        const latestSequence = [...sequences].sort((a, b) =>
            new Date(b.createdAt ?? 0).getTime() - new Date(a.createdAt ?? 0).getTime()
        )[0];

        if (latestSequence?.requireManualApproval === false) {
            return `/campaigns/${campaignId}/overview`;
        }
    } catch {
        // Fall back to the manual-review route if sequence lookup fails.
    }

    return `/campaigns/${campaignId}/review`;
}

export function shouldAutoNavigateAfterCampaignLaunch(path: string): boolean {
    return !/^\/campaigns\/(?:\d+|edit\/\d+|review\/\d+)(?:\/|$)/.test(path);
}

export async function getPostLaunchNavigation(campaignId: number, sourcePath: string) {
    const shouldAutoNavigate = shouldAutoNavigateAfterCampaignLaunch(sourcePath);
    const targetRoute = await getPostLaunchCampaignRoute(campaignId);
    return { targetRoute, shouldAutoNavigate };
}

export function getPostLaunchChatPage(route: string): 'review' | 'campaign-editor' {
    return route.endsWith('/review') ? 'review' : 'campaign-editor';
}
